import { SelectionChangedEvent } from 'ag-grid-community';
import { useIntl } from 'react-intl';
import { TABLE_HEIGHT } from 'common/constants';
import { ComposedTable } from 'components/ComposedTable';
import { useAppDispatch } from 'store/hooks';
import { updateRecordsToRetry } from '../../slice';
import { PaymentDetailsTable, VendorPaymentDetails } from '../../types';
import { failedPaymentTableColumns } from '../../vendorPaymentDetailsColumns';
import { FailedTableHeaderContent } from '../FailedTableHeader';

export const VendorPaymentFailedTable = ({
  data,
  tableHeaderTitle
}: PaymentDetailsTable): React.JSX.Element => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const onRowSelected = (event: SelectionChangedEvent) => {
    dispatch(updateRecordsToRetry(event.api.getSelectedRows()));
  };

  const getRowHeight = (): number =>
    data.some(item => item.failReason.length > 100) ? 50 : 32;

  return (
    <ComposedTable<VendorPaymentDetails>
      columnDefs={failedPaymentTableColumns(intl)}
      rowData={data}
      tableHeaderTitle={tableHeaderTitle}
      useCustomHeader
      customHeight={TABLE_HEIGHT}
      customHeaderContent={gridRef => (
        <FailedTableHeaderContent
          tableHeaderTitle={tableHeaderTitle}
          data={data}
          gridRef={gridRef}
          columnDefs={failedPaymentTableColumns(intl)}
        />
      )}
      rowHeight={getRowHeight()}
      onSelectionChanged={onRowSelected}
      getRowId={param => param.data.vendorNo}
    />
  );
};
